import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
    resourceItem: {
        "&:hover": {
            backgroundColor: theme.colors.structure.pageBackground,
        },
    },
}));
